import { render, staticRenderFns } from "./datacollect-form.vue?vue&type=template&id=3e08daf2&scoped=true&"
import script from "./datacollect-form.vue?vue&type=script&lang=ts&"
export * from "./datacollect-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e08daf2",
  null
  
)

export default component.exports